<template>
  <div class="quiz-page">
    <my-breadcrumb :items="pagination"></my-breadcrumb>

    <div class="quiz-container">
      <div class="aalign-center">
        <my-pagination
          :items="questions" 
          :doubt="doubt"
          v-model="currentQuestionIndex"
          class="aflex-1"
        >
        </my-pagination>
      </div>

      <div class="quiz mt-3" v-if="currentQuestion">
        <div class="quiz__left">
          <h4>Soal {{currentQuestionIndex+1}}</h4>
          <img
            :src="currentQuestion.gallery"
            alt="image"
            v-show="currentQuestion.gallery"
            class="mt-1"
          />
          <div
            v-katex="{expression: currentQuestion.question ? currentQuestion.question : ' ', options: { macros: {' ': '\\space '} }}"
            class="mt-4"
          ></div>
        </div>
        <div class="quiz__right">          
          <div
            class="aalign-start mb-4 quiz__option"
            :class="{
              'quiz__option--active': currentQuestion.givenAnswer === i
            }"
            v-for="(opt, i) in currentQuestion.option_json"
            :key="i"
          >
            <div class="quiz__key mr-3">
              {{ opt.key == 1 ? "A" : opt.key ==2 ? "B" : opt.key == 3 ? "C" : opt.key == 4 ? "D" : "E" }}
            </div>
            <div>
              <div
                v-katex="{expression: opt.option ? opt.option : ' ', options: { macros: {' ': '\\space '} }}"
              ></div>
              <img
                :src="opt.picture"
                alt="ans image"
                v-if="opt.picture"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="quiz mt-3" v-if="currentQuestion">
        <div class="quiz__left">
          <h4>Kunci Jawaban {{currentQuestionIndex+1}}</h4>
          <div class="aalign-start mb-4 quiz__option">
            <div class="quiz__key mr-3">
              {{ answer[currentQuestionIndex].key == 1 ? "A" : answer[currentQuestionIndex].key ==2 ? "B" : answer[currentQuestionIndex].key == 3 ? "C" : answer[currentQuestionIndex].key == 4 ? "D" : "E" }}
            </div>
            <div>
              <div
                v-katex="{expression: answer[currentQuestionIndex].option ? answer[currentQuestionIndex].option : ' ', options: { macros: {' ': '\\space '} }}"
              ></div>
              <img
                :src="answer[currentQuestionIndex].picture"
                alt="ans image"
                v-if="answer[currentQuestionIndex].picture"
                class="mt-2"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="aspace-between aalign-center mt-4">  
        <div></div>      
        <div class="aalign-center">
          <my-button
            class="mr-3 font-bold mb-2"
            type="fill-blue"
            @click="handlePreviousClick" 
            v-if="currentQuestionIndex > 0"
          >
            <fa-icon icon="arrow-left" class="mr-1"></fa-icon>
            Soal Sebelumnya
          </my-button>

          <my-button
            type="fill-blue"
            class="font-bold mb-2"
            @click="handleNextClick" 
            v-if="currentQuestionIndex < (questions.length - 1)"
          >
            Soal Selanjutnya
            <fa-icon icon="arrow-right" class="ml-1"></fa-icon>
          </my-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import * as types from "@/store/types";
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    VueCountdown
  },
  data() {
    return {
      showOverlay:false,
      currentQuestionIndex: 0,
      pagination: [],
      questions: [], 
      answer: [], 
      doubt: [],
      props: {}
    };
  },

  computed: {
    currentQuestion() {
      return this.questions[this.currentQuestionIndex];
    },
    ...mapGetters({
      overlay: types.OVERLAY,
      quiz_result: types.QUIZ_RESULT, 
      section: types.SECTION
    })
  },
  mounted() {
    if(!this.quiz_result.quiz_id || (this.quiz_result.quiz_id != this.$route.params.quiz)) {
      this.restartQuiz();
    } else {
      setTimeout(() => {
        this.showOverlay = false;
      }, 2000);
      this.getQuiz();
    }
  },
  methods: {
    ...mapActions({
      getQuizDetail: types.GET_QUIZ_DETAIL,
      setOverlay: types.SET_OVERLAY
    }),
    restartQuiz() {
      this.$router.push('/class/'+this.section.id+"/quiz/"+this.$route.params.quiz)
    },
    getQuiz() {
      this.setOverlay(true);
      this.getQuizDetail(this.$route.params.quiz)
      .then(response => {
        var res = response;
        this.answer = []
        for (var i = 0; i < res.questions.length; i++) {
          var answer = res.questions[i].option_json
          var result = JSON.parse(this.quiz_result.answer)
          for (var j = 0; j < answer.length; j++) {
            if(answer[j].value == 1) {
              this.answer.push(answer[j])
            }
            if(answer[j].key == result[i].key) {
              res.questions[i].givenAnswer = j;
            }
          }
        }
        this.questions =  res.questions;
        this.pagination = [
          {
            text: res.level,
            url: '#'
          },
          {
            text: res.major ? res.class + " "+ res.major : res.class,
            url: '#'
          },
          {
            text: res.subject,
            url: '#'
          },
          {
            text: res.curriculum,
            url: '#'
          },
          {
            text: res.chapter,
            url: '#'
          },{
            text: res.section,
            url: '#'
          }
        ];
        this.setOverlay(false);
      }).catch(error => {
        this.setOverlay(false);
        this.showMessageBox(error, "Failed to get quiz", "danger");
      })
    },
    showMessageBox(message, title, variant) {
      this.$bvModal.msgBoxOk(message, {
        title: title,
        size: 'sm',
        buttonSize: 'sm',
        okVariant: variant,
        headerClass: 'p-2 border-bottom-0',
        footerClass: 'p-2 border-top-0',
        centered: true
      })
      .then(value => {
        this.temp = value
      })
      .catch(err => {
        this.temp = err;
      });
    },
    handleNextClick() {
      if (this.currentQuestionIndex < this.questions.length - 1) {
        this.currentQuestionIndex++;
      }
    },
    handlePreviousClick() {
      if (this.currentQuestionIndex > 0) {
        this.currentQuestionIndex--;
      }
    }
  }
};
</script>

<style>
.quiz-container {
  padding: 22px 28px;
}

.quiz {
  background: #fff;
  min-height: 200px;
  display: flex;
  flex-wrap: wrap;
}

.quiz__left {
  flex: 1;
  border-right: 1px solid #e6e6e6;
  padding: 23px;
}

.quiz__right {
  flex: 1;
  padding: 23px;
}

.quiz__key {
  width: 24px;
  height: 24px;
  border: solid 1px #949494;
  border-radius: 24px;
  font-weight: 500;
  color: #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.quiz__option {
  cursor: pointer;
}

.quiz__option:hover {
  font-weight: bold;
  color: #009feb;
}

.quiz__option:hover .quiz__key {
  border-color: #009feb;
}

.quiz__option--active {
  font-weight: bold;
  color: #009feb;
}

.quiz__option--active .quiz__key {
  border-color: #009feb;
  background-color: #009feb;
  color: #fff;
  font-weight: bold;
}

span.not-answered {
  font-weight: bold;
  color: #ff216c;
}

.quiz img {
  max-width: 100%;
}

.map-soals {
  display: flex;
  justify-content: center;
  align-self: center;
  flex-wrap: wrap;
  padding: 0 55px;
}

.map-soal {
  width: 40px;
  height: 40px;
  border: solid 1px #dadada;
  background-color: #efefef;
  font-family: Ubuntu;
  font-size: 14px;
  font-weight: 500;
  color: #494949;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5px 8px;
  border-radius: 40px;
  cursor: pointer;
}

.map-soal--active {
  background-color: #fba74f;
  color: #fff;
}

.map-soal--answered {
  background-color: #009feb;
  color: #fff;
}

.belum-disi,
.ragu-ragu,
.sudah-diisi {
  width: 16px;
  height: 16px;
  border-radius: 16px;
  border: solid 1px #dadada;
  background-color: #efefef;
  margin-right: 7px;
}

.ragu-ragu {
  background-color: #fba74f;
}

.sudah-diisi {
  background-color: #009feb;
}

@media only screen and (max-width: 768px) {
  .quiz {
    display: block;
  }
}
</style>
